import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';
import { titleCase } from '@core/util';

@Injectable()
export class HdbTypePreset implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'HDB Type',
        placeholder: 'Please Select',
        displayWith: (value: unknown) => titleCase(value),
        options: this.dataSetupFacade.dataSetup$?.pipe(map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.keyPersonnelHdbTypes))),
      },
    };
  }
}

export function registerHdbTypePreset(): ConfigOption {
  return { presets: [{ name: 'hdbType', config: new HdbTypePreset() }] };
}
